
import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import {
    useDeleteEmailTemplateMutation,
} from "../../Services/settingsAPIs/EmailConfiguration";
import {
    defaultModalStyles,
    dynamicEmailConfigModalStyles,
} from "./../common/CustomModalStyles";
import { useTeamsQuery } from "../../Services/settingsAPIs/CommonAPI";
import CommonDeleteModal, {
    DeleteMessageBody,
} from "../settings/common/CommonDeleteModal";
import { toast } from "react-toastify";
import { useGetTicketTemplatesQuery } from "../../Services/settingsAPIs/TicketSettingsAPI";
import AddTicketTemplateModal from "../settings/ticket/Template/AddTemplateModal";


const SettingTemplate = ({ title }: { title: string }) => {
    const { data: teamsData } = useTeamsQuery({});
    const [selectedTeam, setSelectedTeam] = useState<number>();
    const { data: templatesData, refetch } = useGetTicketTemplatesQuery(
        { pageNo: 1, teamId: selectedTeam, title: title },
        { skip: !selectedTeam }
    );

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [togglerShowTemplate, setTogglerShowTemplate] = useState({
        status: false,
        templateId: 0,
    });
    const [getTempalteData, setGetTemplateData] = useState([]);
    const [theTeams, setTheTeams] = useState([]);
    const [templateForEdit, setTemplateForEdit] = useState<any>({
        templateEditEnabled: false,
        templateData: null,
    });
    const [templateForDeletion, setTemplateForDeletion] = useState<number>();
    const [triggerDeleteEmailTemplateMutation] = useDeleteEmailTemplateMutation();

    const openModal = () => {
        selectedTeam
            ? setIsModalOpen(true)
            : toast.error("Please select a team to add a new template to");
    };
    const closeModal = () => {
        setTemplateForEdit({ templateEditEnabled: false, templateData: null });
        setIsModalOpen(false);
        refetch();
    };

    const [isDeleteEmailTemplateModalOpen, setIsDeleteEmailTemplateModalOpen] =
        useState<boolean>(false);
    const openDeleteEmailTemplateModal = () => {
        setIsDeleteEmailTemplateModalOpen(true);
    };
    const closeDeleteEmailTemplateModal = () => {
        setIsDeleteEmailTemplateModalOpen(false);
        refetch();
    };

    const handleSelectTeamChange = async (event: any) => {
        setSelectedTeam(Number(event.target.value));
    };
    const initiateTemplateEdit = (objForEdit: any) => {
        setTemplateForEdit({ templateEditEnabled: true, templateData: objForEdit });
        openModal();
    };
    const initiateTemplateDeletion = (templateId: number) => {
        setTemplateForDeletion(templateId);
        openDeleteEmailTemplateModal();
    };

    useEffect(() => {
        if (teamsData) setTheTeams(teamsData);
    }, [teamsData]);
    useEffect(() => {
        templatesData && setGetTemplateData(templatesData);
    }, [templatesData]);
    return (
        <div className="container-fluid" style={{ marginLeft: "2%", marginRight: "2%", width: "96%" }}>
            <div className="row" style={{ marginBottom: "-42px" }}>
                <div className="col">
                    <button
                        className="input-group-text align-items-center text-hover-primary fw-bold  float-end "
                        disabled={!selectedTeam}
                        onClick={openModal}
                    >
                        <i className="bi bi-plus-lg me-2"></i>

                        Add
                    </button>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-2">
                    <label>Select team</label>
                    <select
                        className="form-select select2-hidden-accessible"
                        onChange={handleSelectTeamChange}
                        value={selectedTeam}
                    >
                        <option value={0}> Select team </option>
                        {theTeams?.map((el: any) => (
                            <option value={el?.id} key={el?.id}>
                                {el?.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col">
                    <span className="input-group-text mt-2" id="basic-addon1">
                        {title} template
                    </span>
                </div>
            </div>

            <div className="row mt-2" style={{ overflowX: "hidden", maxHeight: "60vh", overflowY: "auto" }}>
                <div className="col">
                    {getTempalteData?.map((el: any, index: any) => (

                        <div
                            style={{
                                boxShadow:
                                    "0 1px 1px -1px grey, 0 1px 1px 0 grey, 0 1px 1px 0 grey",
                                transition: "background-color 0.3s ease",
                            }}
                            className={`${togglerShowTemplate.status &&
                                togglerShowTemplate.templateId === index
                                ? ""
                                : " d-flex"
                                } align-items-center border border-secondary border-2 rounded-2 mt-2 mb-1 p-2`}
                        >
                            <p className="my-0">
                                {togglerShowTemplate.status &&
                                    togglerShowTemplate.templateId === index ? (
                                    <>
                                        <p className="my-0"> {el?.content} </p>
                                        <br />
                                        <strong>{el?.subject}</strong>
                                    </>
                                ) : (
                                    el?.subject
                                )}
                            </p>
                            <div className="ms-auto">
                                <button
                                    className="btn btn-link text-hover-info"
                                    onClick={() => initiateTemplateEdit(el)}
                                >
                                    <i className="ms-auto bi bi-pencil fs-2"></i>
                                </button>
                                <button
                                    className="btn btn-link text-hover-danger"
                                    onClick={() => initiateTemplateDeletion(el.id)}
                                >
                                    <i className="bi bi-trash fs-2 mx-2"></i>
                                </button>
                            </div>
                        </div>

                    ))}
                </div>
            </div>

            <ReactModal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                style={dynamicEmailConfigModalStyles}
                contentLabel="Add/Edit a template"
                shouldCloseOnOverlayClick={false}
            >
                <AddTicketTemplateModal
                    closeModal={closeModal}
                    selectedTeam={selectedTeam}
                    refetchTemplates={refetch}
                    templateForEdit={templateForEdit}
                    title={title}
                />
            </ReactModal>
            <ReactModal
                isOpen={isDeleteEmailTemplateModalOpen}
                onRequestClose={closeDeleteEmailTemplateModal}
                style={defaultModalStyles}
                contentLabel="Delete a selected workflow"
                shouldCloseOnOverlayClick={false}
            >
                <CommonDeleteModal
                    closeModal={closeDeleteEmailTemplateModal}
                    deleteAPItrigger={triggerDeleteEmailTemplateMutation}
                    deletionIdentifier={templateForDeletion}
                    messageBody={
                        <DeleteMessageBody
                            bodyParams={{
                                descriptionPromptEnabled: false,
                                deletionOf: "template",
                            }}
                        />
                    }
                />
            </ReactModal>
        </div>
    );
};


export default SettingTemplate